import React from 'react';
import { useTranslation } from 'react-i18next';
import CompletedInformationIllustration from '../../../resources/assets/illustrations/CompletedInformationIllustration';

export default function CompleteVerification() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Verification:Status:CompleteVerification' });

  return (
    <div className="p-md">
      <div className="flex flex-col lg:flex-row lg:items-center mx-auto">
        <div className="relative lg:w-5/12 text-center max-w-[32rem] mx-auto lg:max-w-[none] lg:text-left">
          <h5 className="mb-2">{t('title')}</h5>
          <p className="text-[#6B7280]">{t('description')}</p>
        </div>
        <div className="relative p-4 lg:mt-0 flex-1 flex flex-col justify-center items-center lg:items-end lg:p-4 lg:self-end order-first lg:order-last mb-8 lg:mb-0">
          <CompletedInformationIllustration />
        </div>
      </div>
    </div>
  );
}
